export enum OwnerInfoScreenLayouts {
  MobileFirst = 'mobile-first',
  MobileSecond = 'mobile-second',
  Desktop = 'desktop',
  DesktopOrMobileFirst = 'desktop-or-mobile-first',
  DesktopOrMobileSecond = 'desktop-or-mobile-second',
  DesktopOrMobileThird = 'desktop-or-mobile-third',
  DesktopOrMobileFormVisible = 'desktop-or-mobile-form-visible',
  DesktopOrMobileFormNotVisible = 'desktop-or-mobile-form-not-visible',
};